import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { DialogConfirmacionRegistroComponent } from 'src/app/_shared/_dialogs/dialog-confirmacion-registro/dialog-confirmacion-registro.component';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnClickComponent } from 'src/app/_shared/bloque-buttons/btn-click/btn-click.component';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';
import { ProgressBarComponent } from 'src/app/_shared/bloque-ficha/progress-bar/progress-bar.component';
import { FAC_Operacion } from 'src/app/factoring/shared/_models/operacion';
import { SellosComponent } from 'src/app/factoring/shared/utils/sellos/sellos.component';

@Component({
  selector: 'app-ficha-una-oportunidad',
  standalone: true,
  imports: [
    SharedModule,
    ProgressBarComponent,
    SellosComponent,
    BtnLinkComponent,
    BtnClickComponent
  ],
  templateUrl: './ficha-una-oportunidad.component.html',
  styleUrl: './ficha-una-oportunidad.component.scss'
})
export class FichaUnaOportunidadComponent implements OnInit
{
  @Input() oportunidad: FAC_Operacion;
  @Input() isLogged: boolean;
  isPlatformFactoring: boolean = false;
  domainUrl: string;

  constructor(
    private _dialog: MatDialog,
    private _platformService: PlatformService
  ) { }
  
  ngOnInit(): void
  {
     this.isPlatformFactoring = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment] == 'FACTORING' ? true : false;
    this.domainUrl = this._platformService.getSubdominioUrl('factoring');
  }
  openModal(): void
  {
    this._dialog.open(DialogConfirmacionRegistroComponent, { panelClass: 'dialog-sin-padding', autoFocus: false, data: { returnUrl: this.oportunidad.operacionId, isPlatformFactoring: this.isPlatformFactoring, domainUrl: this.domainUrl } });
  }

}
